import Image1 from "../../assets/images/product-hero.jpeg";
import Paragraph from "../../components/Paragraph/Paragraph";
import TableComponent from "../../components/Table/Table";

export const ProductsContent = {
  heroBreadCrumb: {
    image: Image1,
    header: "Discover Our High-Quality Pharmaceutical Products",
    description: `Elevate Your Expectations with RAYKOS's Next-Generation Pharmaceutical Products`,
  },
  paragraph1: {
    header: "About Our Products",
    description:
      "At RAYKOS, we are dedicated to manufacturing and supplying a diverse range of pharmaceutical products that meet the highest standards of quality and efficacy. With our state-of-the-art facilities and commitment to innovation, we strive to provide healthcare solutions that make a difference in lives.",
  },
  productsList: {
    labelText: "Select Product Type",
    tabs: [
      {
        id: "1",
        label: "Immediate Release Pellets",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "IMMEDIATE RELEASE PELLETS",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Category",
              ],
              data: [
                {
                  "product name": "Caffeine",
                  category: "Stimulant",
                },
                {
                  "product name":
                    "Cetirizine Dihydrochloride",
                  category: "Antihistamine",
                },
                {
                  "product name":
                    "Chlorpheniramine Maleate",
                  category: "Decongestant",
                },
                {
                  "product name": "Domperidone IR & SR",
                  category: "Anti-Emetic",
                },
                {
                  "product name": "Doxycycline Hyclate",
                  category: "Antibiotic",
                },
                {
                  "product name": "Itraconazole",
                  category: "Anti-Fungal",
                },
                {
                  "product name":
                    "Levocetirizine Dihydrochloride",
                  category: "Antihistamine",
                },
                {
                  "product name":
                    "Meclizine Hydrochloride",
                  category: "Anti-Emetic",
                },
                {
                  "product name": "Orlistat",
                  category: "Anti-Obesity",
                },
                {
                  "product name":
                    "Phenylephrine Hydrochloride IR & SR",
                  category: "Decongestant",
                },
                {
                  "product name":
                    "Tramadol Hydrochloride IR & SR",
                  category: "Analgesic",
                },
              ],
            },
          },
        ],
      },
      {
        id: "2",
        label: "Delayed Release Pellets",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "DELAYED RELEASE PELLETS",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Category",
              ],
              data: [
                {
                  "product name": "Aspirin EC",
                  category: "Anti-Inflammatory",
                },
                {
                  "product name":
                    "Diclofenac Potassium EC & SR",
                  category: "Anti-Inflammatory",
                },
                {
                  "product name":
                    "Diclofenac Sodium EC & SR",
                  category: "Anti-Inflammatory",
                },
                {
                  "product name":
                    "Esomeprazole EC",
                  category: "Anti-ulcerative",
                },
                {
                  "product name": "Lansoprazole EC",
                  category: "Anti-ulcerative",
                },
                {
                  "product name": "Omeprazole EC",
                  category: "Anti-ulcerative",
                },
                {
                  "product name": "Pantoprazole EC",
                  category: "Anti-ulcerative",
                },
                {
                  "product name":
                    "Rabeprazole Sodium EC",
                  category: "Anti-ulcerative",
                },
                {
                  "product name": "Domperidone EC",
                  category: "Anti-emetic",
                },
                {
                  "product name": "Fluoxetine HCl EC",
                  "strength (w/w)": "39.15%",
                  category: "Antidepressant",
                },
                {
                  "product name": "Duloxetine HCl EC",
                  category: "Antidepressant",
                },
              ],
            },
          },
        ],
      },
      {
        id: "3",
        label: "Sustained Release Pellets",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "SUSTAINED RELEASE PELLETS",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Category",
              ],
              data: [
                {
                  "product name":
                    "Ketoprofen",
                  category: "Anti-inflammatory",
                },
                {
                  "product name":
                    "Diltiazem Hydrochloride",
                  category: "Anti-Hypertensive",
                },
                {
                  "product name": "Nifedipine",
                  category: "Anti-Hypertensive",
                },
                {
                  "product name": "Propranolol Hydrochloride",
                  category: "Anti-Hypertensive",
                },
                {
                  "product name": "Fenofibrate",
                  category: "Hypercholesterolemina",
                },
                {
                  "product name":
                    "Itopride Hydrochloride",
                  category: "GI Prokinetic",
                },
                {
                  "product name":
                    "Tamsulosine Hydrochloride",
                  category: "BPH",
                },
                {
                  "product name": "Theophylline",
                  category: "Brancho Dilator",
                },
                {
                  "product name":
                    "Ambroxol Hydrochloride",
                  category: "Expectorent",
                },
                {
                  "product name":
                    "Mebeverine Hydrochloride",
                  category: "Antispasmodic",
                },
                {
                  "product name":
                    "Venlafaxine Hydrochloride",
                  category: "Antidepressant",
                },
              ],
            },
          },
        ],
      },
      {
        id: "4",
        label: "Blended Pellets in Combination",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "BLENDED PELLETS IN COMBINATION",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Strength (W/W)",
              ],
              data: [
                {
                  "product name":
                    "Omeprazole EC & Domperidone",
                  "strength (w/w)": "70mg, 35mg",
                },
                {
                  "product name":
                    "Pantoprazole EC & Domperidone SR",
                  "strength (w/w)": "110mg, 82.5mg",
                },
                {
                  "product name":
                    "Pantoprazole EC & Itopride HCl SR",
                  "strength (w/w)": "80mg, 300mg",
                },
                {
                  "product name":
                    "Rabeprazole Sodium EC & Domperidone SR",
                  "strength (w/w)": "70mg, 35mg",
                },
                {
                  "product name":
                    "Rabeprazole Sodium EC & Itopride HCl SR",
                  "strength (w/w)": "40mg, 300mg",
                },
              ],
            },
          },
        ],
      },
      {
        id: "5",
        label: "Nutraceutical Pellets",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "NUTRACEUTICAL PELLETS",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Strength (W/W)",
              ],
              data: [
                {
                  "product name": "Ascorbic Acid Pellets",
                  "strength (w/w)": "60.0%, 70.0%",
                },
                {
                  "product name":
                    "Calcium Pantothenate Pellets",
                  "strength (w/w)": "10.0%",
                },
                {
                  "product name": "Carbonyl Iron Pellets",
                  "strength (w/w)": "50.0%, 65.0%",
                },
                {
                  "product name": "Cyanocobalamin",
                  "strength (w/w)": "0.10%",
                },
                {
                  "product name":
                    "Dried Ferrous Sulphate Pellets SR",
                  "strength (w/w)": "50.0%, 62.0%",
                },
                {
                  "product name": "Folic Acid Pellets",
                  "strength (w/w)": "3.0%, 5.0%",
                },
                {
                  "product name": "Niacinamide Pellets",
                  "strength (w/w)": "50.0%",
                },
                {
                  "product name": "Riboflavin Pellets",
                  "strength (w/w)": "5.0%",
                },
                {
                  "product name":
                    "Thiamine Mononitrate Pellets",
                  "strength (w/w)": "5.0%",
                },
                {
                  "product name": "Pyridoxine Hcl Pellets",
                  "strength (w/w)": "10.0%, 26.0%",
                },
                {
                  "product name":
                    "Zinc Sulphate Monohydrate Pellets",
                  "strength (w/w)": "65.0%",
                },
              ],
            },
          },
        ],
      },
      {
        id: "6",
        label: "Injections",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "INJECTIONS",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Strength",
                "Dose"
              ],
              data: [
                {
                  "product name": "Diclofenac Sodium",
                  "strength": "25 mg",
                  "dose": "3/20/30mL"
                },
                {
                  "product name": "Gentamycin",
                  "strength": "40mg",
                  "dose": "2/10/20/30mL"
                },
                {
                  "product name": "Cynacobalmin",
                  "strength": "500mcg",
                  "dose": "20/30mL"
                },
                {
                  "product name": "B-Complex",
                  "strength": "-",
                  "dose": "3/10/20/30mL",
                },
                {
                  "product name": "Paracetamol",
                  "strength": "75mg",
                  "dose": "2/20/30mL"
                },
                {
                  "product name": "Ranitidine",
                  "strength": "25mg",
                  "dose": "2mL"
                },
                {
                  "product name": "Adrenaline",
                  "strength": "1mg",
                  "dose": "1/2mL"
                },
                {
                  "product name": "Frusemide",
                  "strength": "10mg",
                  "dose": "2mL"
                },
                {
                  "product name": "Chloroquine Phosphate",
                  "strength": "64.5mg",
                  "dose": "2/5/20/30mL"
                },
                {
                  "product name": "Pantoprazole",
                  "strength": "40mg",
                  "dose": "-"
                },
                {
                  "product name": "Hydrocartizone  Sodium Succinate",
                  "strength": "100mg",
                  "dose": "-"
                },
                {
                  "product name": "Vancomycin",
                  "strength": "500mg",
                  "dose": "-"
                },
                {
                  "product name": "Artesunate",
                  "strength": "60mg",
                  "dose": "5mL"
                },
                {
                  "product name": "Protamine sulfate",
                  "strength": "10mg",
                  "dose": "5mL"
                },
                {
                  "product name": "Dopamine",
                  "strength": "40mg",
                  "dose": "5mL"
                },
                {
                  "product name": "Meropenem",
                  "strength": "500/1000mg",
                  "dose": "-"
                },
                {
                  "product name": "Tramadol",
                  "strength": "50mg",
                  "dose": "-"
                },
                {
                  "product name": "Iron Sucrose",
                  "strength": "20mg",
                  "dose": "5mL"
                },
                {
                  "product name": "Lidocaine & Adrenaline",
                  "strength": "20/0.01mg",
                  "dose": "2/30mL"
                },
                {
                  "product name": "Oxytocin",
                  "strength": "1mL",
                  "dose": "-"
                },
                {
                  "product name": "Amikacin Sulphate",
                  "strength": "125/250mg",
                  "dose": "-"
                },
                {
                  "product name": "Ondensetron HCl",
                  "strength": "2mg",
                  "dose": "-"
                },
                {
                  "product name": "Aceclofenac",
                  "strength": "150mg",
                  "dose": "-"
                },
                {
                  "product name": "Piroxicam",
                  "strength": "20mg",
                  "dose": "1/2mL"
                },
                {
                  "product name": "Ofloxacin",
                  "strength": "0.3%w/w",
                  "dose": "5/10mL"
                },
                {
                  "product name": "Ceftriaxone & Sulbactum",
                  "strength": "500/250mg",
                  "dose": "-"
                },
                {
                  "product name": "",
                  "strength": "1000/500mg",
                  "dose": "-"
                },
                {
                  "product name": "Cefoperazone & Sulbactum",
                  "strength": "1000/500mg",
                  "dose": "-"
                },
                {
                  "product name": "Ceftriaxone",
                  "strength": "250/500/1000mg",
                  "dose": "-"
                },
                {
                  "product name": "Piperacillin & Tazobactum",
                  "strength": "4g/500mg",
                  "dose": "-"
                },
                {
                  "product name": "",
                  "strength": "2g/250mg",
                  "dose": "-"
                },
                {
                  "product name": "Ceftriaxone & Tazobatum",
                  "strength": "500/62.5mg",
                  "dose": "-"
                },
                {
                  "product name": "",
                  "strength": "1000/125mg",
                  "dose": "-"
                },{
                  "product name": "Ampicillin",
                  "strength": "250/500mg",
                  "dose": "-"
                },
                {
                  "product name": "Betamethazone Sodium",
                  "strength": "4mg",
                  "dose": "-"
                },
              ],
            },
          },
        ],
      },
      {
        id: "7",
        label: "Cephalosporins",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "CEPHALOSPORINS",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Strength",
              ],
              data: [
                {
                  "product name": "Cefdinir Capsules",
                  "strength": "300 mg",
                },
                {
                  "product name":
                    "Cefdinir Oral Suspension",
                  "strength": "125 mg / 5 mL",
                },
                {
                  "product name": "",
                  "strength": "250 mg / 5 mL",
                },
                {
                  "product name": "Cefixime Oral Suspension",
                  "strength": "100 mg / 5 mL",
                },
                {
                  "product name": "",
                  "strength": "200 mg / 5 mL",
                },
                {
                  "product name": "Cefpodoxime Proxetil Tablets",
                  "strength": "100 mg",
                },
                {
                  "product name": "",
                  "strength": "200 mg",
                },
                {
                  "product name":
                    "Cefprozil Oral Suspension",
                  "strength": "125 mg / 5 mL",
                },
                {
                  "product name": "",
                  "strength": "250 mg / 5 mL",
                },
                {
                  "product name": "Cephalexin Capsules",
                  "strength": "250 mg",
                },
                {
                  "product name": "",
                  "strength": "500 mg",
                },
              ],
            },
          },
        ],
      },
      {
        id: "8",
        label: "Betalactum",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "BETALACTUM",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Strength",
              ],
              data: [
                {
                  "product name": "Amoxicillin Capsules",
                  "strength": "250 mg",
                },
                {
                  "product name": "",
                  "strength": "500mg",
                },
                {
                  "product name": "Amoxicillin Oral Suspension",
                  "strength": "400 mg / 5 mL",
                },
                {
                  "product name": "",
                  "strength": "125 mg / 5 mL",
                },
                {
                  "product name": "",
                  "strength": "200 mg / 5 mL",
                },
                {
                  "product name": "",
                  "strength": "250 mg / 5 mL",
                },
                {
                  "product name": "",
                  "strength": "400 mg / 5 mL",
                },
                {
                  "product name": "Amoxicillin Tablets",
                  "strength": "500mg",
                },
                {
                  "product name": "",
                  "strength": "875 mg",
                },
                {
                  "product name": "Amoxicillin/Clavulanate Tablets",
                  "strength": "500 / 125 mg",
                },
                {
                  "product name": "",
                  "strength": "875 / 125 mg",
                },
                {
                  "product name": "",
                  "strength": "250 mg/125 mg",
                },
                {
                  "product name": "Amox Clavulanate Oral Suspensiomn",
                  "strength": "200-28.5 mg / 5mL",
                },
                {
                  "product name": "",
                  "strength": "250-62.5 mg / 5 mL",
                },
                {
                  "product name": "",
                  "strength": "400-57 mg / 5mL",
                },
                {
                  "product name": "",
                  "strength": "600-42.9 mg / 5mL",
                },
              ],
            },
          },
        ],
      },
      {
        id: "9",
        label: "Supplements",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "SUPPLEMENTS",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Strength",
              ],
              data: [
                {
                  "product name": "Ascorbic Acid Chewable Tablets",
                  "strength": "500 mg, 1000 mg",
                },
                {
                  "product name": "Acetylcysteine Tablets",
                  "strength": "600 mg",
                },
                {
                  "product name": "Acetylcysteine Capsules",
                  "strength": "600 mg",
                },
                {
                  "product name": "Cyanocobalamin Tablets",
                  "strength": "50 mcg, 100 mcg, 1000 mcg",
                },
                {
                  "product name": "Colecalciferol (Vitamin D3) Capsules",
                  "strength": "800 IU",
                },
                {
                  "product name": "Colecalciferol (Vitamin D3) Tablets",
                  "strength": "800 IU",
                },
                {
                  "product name": "Calcium Carbonate + Colecalciferol (Vitamin D3) Tablets",
                  "strength": "1250 mg + 400 IU",
                },
                {
                  "product name": "Calcium Carbonate + Colecalciferol (Vitamin D3) Capsules",
                  "strength": "450 mg + 175 IU",
                },
                {
                  "product name": "",
                  "strength": "500 mg + 800 IU",
                },
                {
                  "product name": "Calcium Carbonate Tablets",
                  "strength": "1250 mg",
                },
                {
                  "product name": "Calcium Lactate + Calcium Phosphate + Ergocalciferol (Vitamin D2) Tablets",
                  "strength": "300 mg + 150 mg + 400 IU",
                },
                {
                  "product name": "Ferrous Fumarate Tablets",
                  "strength": "210 mg, 322 mg",
                },
                {
                  "product name": "Ferrous Fumarate Capsules",
                  "strength": "305 mg",
                },
                {
                  "product name": "Ferrous Gluconate Tablets",
                  "strength": "300 mg",
                },
                {
                  "product name": "Ferrous Sulphate Tablets",
                  "strength": "200 mg",
                },
                {
                  "product name": "Folic Acid Tablets",
                  "strength": "5 mg",
                },
                {
                  "product name": "Nicotinamide + Pyridoxine Hcl + Riboflavin + Thiamine Mononitrate Tablets",
                  "strength": "20 mg + 2 mg + 2 mg + 4.85 mg",
                },
                {
                  "product name": "Sodium Bicarbonate Capsules",
                  "strength": "500 mg",
                },
                {
                  "product name": "Sodium Bicarbonate Tablets",
                  "strength": "600 mg",
                },
                {
                  "product name": "Thiamine Tablets",
                  "strength": "50 mg, 100 mg",
                },
              ],
            },
          },
        ],
      },
      {
        id: "10",
        label: "Solid Doses",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "SOLID DOSAGES - TABLETS & CAPSULES",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: [
                "Product name",
                "Form",
                "Strength",
              ],
              data: [
                { "product name": "Paracetamol", form: "Tablet", strength: "500 mg" },
                { "product name": "Ibuprofen", form: "Tablet", strength: "200 mg" },
                { "product name": "Amoxicillin", form: "Capsule", strength: "500 mg" },
                { "product name": "Cefixime", form: "Tablet", strength: "100 mg" },
                { "product name": "Metformin", form: "Tablet", strength: "500 mg" },
                { "product name": "Omeprazole", form: "Capsule", strength: "20 mg" },
                { "product name": "Amlodipine", form: "Tablet", strength: "5 mg" },
                { "product name": "Levocetirizine", form: "Tablet", strength: "5 mg" },
                { "product name": "Cetirizine", form: "Tablet", strength: "10 mg" },
                { "product name": "Doxycycline", form: "Capsule", strength: "100 mg" },
              ],
            },
          },
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center pt-3",
              content: {
                description: "...and many more products available.",
              },
            },
          },
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center pt-4",
              content: {
                description: "Our solid dosage capabilities include immediate‑release and modified‑release tablets, capsules, and enteric‑coated formulations.",
              },
            },
          },
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center pb-4",
              content: {
                description: "All products manufactured under GMP and meeting regulatory requirements.",
              },
            },
          }
        ],
      },
      {
        id: "11",
        label: "Oral Thin Film",
        content: [
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-4",
              content: {
                header: "ORAL THIN FILM (OTF)",
              },
            },
          },
          {
            component: TableComponent,
            props: {
              headers: ["Product name", "Strength", "Indication"],
              data: [
                { "product name": "Melatonin", strength: "3 mg", indication: "Sleep aid" },
                { "product name": "Vitamin B12", strength: "1000 mcg", indication: "Nutritional supplement" },
                { "product name": "Rapid-Dissolve Analgesic", strength: "50 mg", indication: "Pain relief" },
                { "product name": "Multi-Vitamin", strength: "Varied", indication: "Nutritional support" },
              ],
            },
          },
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center pt-3",
              content: {
                description: "...and many more products available.",
              },
            },
          },
          {
            component: Paragraph,
            props: {
              isPageHeader: false,
              linkClass: "text-center py-3",
              content: {
                description: "Oral thin films provide fast onset, convenient dosing and easy administration without water — available in custom strengths and flavours with scalable manufacturing options.",
              },
            },
          },
        ],
      },
    ],
  },
  sectionBanner: {
    description: "Have any question, contact us.",
    button: {
      url: "/contact",
      name: "Contact US",
    },
  },
};
